var MonthFormat;
(function (MonthFormat) {
  MonthFormat["SHORT"] = "short";
  MonthFormat["LONG"] = "long";
})(MonthFormat || (MonthFormat = {}));

export { MonthFormat };
//# sourceMappingURL=monthFormat.mjs.map
